import PropTypes from "prop-types";
import React from "react";
import { priceType, subscribeLinkType } from "../common/types";

export function Pricing({
	packageName,
	description,
	downloadsDescription,
	subscriptionOption,
	subscribeLink,
	price,
	children,
}) {
	return (
		<section className="section--subscription section--dark">
			<div className="container">
				<header className="flex justify-space-between align-center">
					<h2 className="section-title">
						Pricing
						<br /> {packageName}
					</h2>
				</header>

				<section className="subscription grid justify-space-between">
					<div className="subscription__pro grid__col-lg-auto grid__col-12">
						<div className="pro__content">
							<div className="pro__heading">
								<p className="h4">Online subscription</p>
							</div>
							<div className="pro__typography typography">
								<p>{description}</p>
								<ul className="ticks ticks--small">
									{subscriptionOption && (
										<li>{subscriptionOption}</li>
									)}
									<li>Comprehensive search filters</li>
									<li>
										Seamless integration and real-time
										updates
									</li>
								</ul>
							</div>
						</div>
						<div className="grid justify-space-between pro__content pro__price">
							<div className="price__year grid__col-12 grid__col-sm-4 justify-center">
								<span>Starting from</span>
								<div className="price-total">
									<span className="value">{price}</span>
									<span className="currency">€</span>/year
								</div>
							</div>
							<div className="price__contact grid__col-12 grid__col-sm-8">
								<a
									href={subscribeLink}
									className="subscribe-link btn btn--primary"
								>
									Subscribe now
								</a>
							</div>
						</div>
					</div>
					<div className="subscription__trial grid__col-lg-4 grid__col-12">
						<p className="h4">Data downloads</p>
						<div className="typography">
							<p>{downloadsDescription}</p>
							<p className="h6">
								{packageName} can be integrated into your
								systems
							</p>
							<ul className="ticks ticks--small">
								<li>
									Book a call – request a quote, contact
									sales, etc
								</li>
								<li>Learn more about data feeds here</li>
							</ul>
						</div>
						<a
							className="btn btn--tertiary"
							href="mailto:sales@ch-aviation.com"
						>
							Contact sales
						</a>
					</div>
				</section>
			</div>
			{children}
		</section>
	);
}

Pricing.propTypes = {
	packageName: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	downloadsDescription: PropTypes.string.isRequired,
	subscriptionOption: PropTypes.string,
	subscribeLink: subscribeLinkType.isRequired,
	price: priceType.isRequired,
	children: PropTypes.node.isRequired,
};
